import React from 'react'; // Ajoutez cette ligne
import { withStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';

const StyledTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': { padding: '10px 14px' },
        '& .MuiOutlinedInput-root': {
            borderRadius: theme.shape.borderRadius,
            '& fieldset': { borderColor: theme.palette.grey[300] },
            '&:hover fieldset': { borderColor: theme.palette.grey[500] },
            '&.Mui-focused fieldset': { borderColor: theme.palette.primary.main },
        },
        '& .MuiInputLabel-root': { color: theme.palette.text.secondary },
    },
}))(TextField);

// Fonction pour sélectionner le texte dans l'input
const handleFocus = (event) => {
    event.target.select();
};

const CustomTextField = (props) => {
    return (
        <StyledTextField
            {...props}
            inputProps={{
                ...props.inputProps,
                onFocus: handleFocus,
            }}
        />
    );
};

export default CustomTextField;
